  export async function getResizedCanvas(file, maxWidthParam = 1200, maxHeightParam = 800) {
        return new Promise((resolve) => {
          const img = document.createElement('img'); 
         //define event listener before adding image src 
          img.addEventListener('load', () => {
            const canvas = document.createElement("canvas");
            const ctx = canvas.getContext("2d");
            
            const maxWidth = maxWidthParam;
            const isLandscape = img.width >= img.height; 

            const maxHeight = maxHeightParam; 

            if (isLandscape) {
              if (img.width <= maxWidth) {
                //dont change size at all 
                canvas.width = img.width; 
                canvas.height = img.height; 

                ctx.clearRect(0,0,canvas.width, canvas.height); 
                ctx.drawImage(img, 0,0, img.width, img.height); 
              } else {
                //scale so width is 1200px 
                canvas.width = maxWidth; 
                let wRatio = maxWidth / img.width; 
                canvas.height = img.height * wRatio; 

                ctx.clearRect(0,0,canvas.width, canvas.height);   
                ctx.drawImage(img, 0,0, img.width, img.height,
                0,0,canvas.width, canvas.height);  
              }
            } else {
              if (img.height <= maxHeight) {
                  //dont change size at all. 
                canvas.width = img.width; 
                canvas.height = img.height; 

                ctx.clearRect(0,0,canvas.width, canvas.height); 
                ctx.drawImage(img, 0,0, img.width, img.height); 
              } else {
                //scale so height is 800px 
                canvas.height = maxHeight; 
                let hRatio = maxHeight / img.height; 
                canvas.width = img.width * hRatio; 

                ctx.clearRect(0,0,canvas.width, canvas.height);   
                ctx.drawImage(img, 0,0, img.width, img.height,
                0,0,canvas.width, canvas.height);  
              }
            }
            resolve(canvas); 
          }); 
          //set the src. this will cause the event listener to fire. 
          img.src = URL.createObjectURL(file); 
        });   
      }; 